import type { CSSProperties } from "react";
const paths: Record<string, string> = {
  queue: "M4 6h16M4 12h16M4 18h10",
  dashboard: "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z",
  users:
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M16 3a4 4 0 0 1 0 8M22 21v-2a4 4 0 0 0-3-3.87M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
  chat: "M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5",
  bank: "M3 5h18v14H3zM3 10h18M7 15h3",
  mail: "M3 5h18v14H3zM3 6l9 7 9-7",
  file: "M14 2H6v20h14V8zM14 2v6h6M9 13h8M9 17h6",
  court: "M12 3v18M7 21h10M4 7h16M5 7l-3 7h6zM19 7l-3 7h6z",
  form: "M5 3h14v18H5zM9 7h6M9 12h6M9 17h3",
  phone: "M7 2h10v20H7zM11 18h2",
  chart: "M4 20V10M10 20V4M16 20v-7M2 20h20",
  book: "M12 5c-3-2-6-2-10-1v15c4-1 7-1 10 1 3-2 6-2 10-1V4c-4-1-7-1-10 1zM12 5v15",
  settings:
    "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8M9 3l-1 3-3 1-2 3 2 2-1 3 2 3 3-1 2 4h3l1-3 3-1 2-3-2-2 1-3-2-3-3 1-2-4z",
  search: "M21 21l-5-5M18 10.5a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0",
  plus: "M12 5v14M5 12h14",
  spark: "M12 3l2.3 6.7L21 12l-6.7 2.3L12 21l-2.3-6.7L3 12l6.7-2.3z",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4",
  clock: "M12 8v4l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
  chevron: "M9 5l7 7-7 7",
  down: "M6 9l6 6 6-6",
  check: "M5 12l4 4L19 6",
  close: "M6 6l12 12M6 18L18 6",
  download: "M12 3v12M7 10l5 5 5-5M4 16v5h16v-5",
  upload: "M12 16V3M7 8l5-5 5 5M4 16v5h16v-5",
  arrow: "M5 12h14M13 6l6 6-6 6",
  back: "M19 12H5M11 6l-6 6 6 6",
  shield: "M12 2l9 4v6c0 5-9 10-9 10S3 17 3 12V6zM8 11l3 3 5-5",
  menu: "M3 6h18M3 12h18M3 18h18",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  flag: "M4 22V3c5-4 11 4 16 0v12c-5 4-11-4-16 0",
  lock: "M5 10h14v12H5zM8 10V6a4 4 0 0 1 8 0v4",
  send: "M22 2L9 15M22 2l-7 20-6-7-7-6z",
  wallet: "M3 5h18v15H3zM3 5V3h14M16 11h5v5h-5z",
  trend: "M3 17l6-6 4 4 8-10M15 5h6v6",
  info: "M12 11v6M12 7h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
  logout: "M9 4H3v16h6M14 8l4 4-4 4M9 12h12",
  calendar: "M4 5h16v16H4zM8 2v6M16 2v6M4 10h16",
  globe:
    "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M3 12h18M12 3c5 5 5 13 0 18-5-5-5-13 0-18",
  heart:
    "M20.8 4.6a5.5 5.5 0 0 0-7.8 0l-1 1-1-1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8",
  folder: "M3 5h7l2 3h9v13H3z",
};
export function Icon({
  name,
  className = "",
  style,
}: {
  name: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      className={`icon w-4.5 h-4.5 flex-none ${className}`}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name] || paths.file} />
    </svg>
  );
}
